/*------------------------------------*\
    MOBILE-COLLAPSE
\*------------------------------------*/
class MobileCollapse {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        let trigger = self.elem.querySelector('.js-mobile-collapse-trigger');
        let content = self.elem.querySelector('.js-mobile-collapse-content');

        trigger.addEventListener('click', evt => {
            content.classList.toggle('is-open');
            trigger.classList.toggle('is-open');
        });
    }
}

export default MobileCollapse;
